<template>
<div>

  <v-container mt-0 pt-0 >

    <v-layout >
      <v-flex xs12 class="text-xs-center">
      <p> </p>
      <v-progress-circular indeterminate :size="50" 
      color="primary" 
      :width="7" 
      v-if="loading"></v-progress-circular>
      </v-flex>
    </v-layout>
    <v-layout >
      <v-flex xs12 pa-4 class="text-xs-center">
        <h2>Get Involved</h2>
        <p>Register to participate</p>
        <v-btn flat v-for="item in menuItems" 
              :key="item.title"
              :to="item.link">
             <v-icon left>{{ item.icon }}</v-icon>
             {{ item.title }}
             </v-btn>
     </v-flex>
     </v-layout>
     
  </v-container>
  </div>
</template>

<script>
 export default {
   data () {
     return {
       trackInfo:[],
       prelaunch:false,
       
     }
   },
   
   computed: {
    
      menuItems () {
        let menuItems = [
          //{icon: 'face', title: 'Sign Up', link: '/signup'},
          //{icon: 'lock_open', title: 'Sign In', link: '/signin'},
          {icon: 'movie', title: 'Upload content', link: '/content/new'}
        ]
        return menuItems
      },
     userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      }
   },
   
   methods: {
     
   }
 }
</script>

<style scoped>
  .title{
    position:absolute;
    bottom:50px;
    background-color:rgba(0,0,0,0.5);
    color:#fff;
    padding:5px;
    font-size:2em;


  }
</style>



// WEBPACK FOOTER //
// src/components/Involved.vue